<template lang="pug">
.create-user
  .form-wrapper
    header.headline
      h1.headline__title {{title}}
    form(ref="formNew")
      .c-form
          .c-form__form-row.c-form__form-row--full
            header.headline
                h2.headline__title.headline__title--font-size crea un nuevo usuario
          .c-form__form-row.c-form__form-row--full( v-if="create.Executive")
            label(class="c-form__form-label") COMPAÑÍAS
            b-taginput(
              v-model="formData.companies"
              :data="filteredCompanies"
              autocomplete
              field="name"
              icon="label"
              placeholder="Add a tag"
              @typing="getFilteredCompanies")
                template(slot-scope="props") {{props.option.name}}
          .c-form__form-row.c-form__form-row--full( v-if="create.Executive" )
            label(class="c-form__form-label") TIPO DE COMERCIAL
            select(v-model="formData.executiveType" @change="selectExecutiveType()" id="user_type", name="user_type", required)
                option(:value=1 ) COMERCIAL SUPERVISOR DE EQUIPO
                option(:value=2 ) COMERCIAL OPERATIVO
          .c-form__form-row.c-form__form-row--full( v-if="create.Technical" )
            label(class="c-form__form-label") TIPO DE TECNICA
            select(v-model="formData.technicalType" @change="selectTechnicalType()" id="user_type", name="user_type", required)
                option(:value=1 ) TECNICA SUPERVISOR DE EQUIPO
                option(:value=2 ) TECNICA OPERATIVO
          .c-form__form-row.c-form__form-row--full( v-if="create.Technical" )
            label(class="c-form__form-label") EQUIPO 
            select(v-model="formData.technicalBag" id="user_type", name="technica_bag", required)
                option(:value="technicalBag.id" v-for="technicalBag in listTechnicalBags" ) {{technicalBag.name}}
          .c-form__form-row.c-form__form-row--full( v-if="create.Technical" )
            label(class="c-form__form-label") TECNICA SUPERIOR
            select(v-model="formData.technicalSuperior" id="user_type", name="user_type", required)
                option(:value="technicalSuperior.id" v-for="technicalSuperior in listTechnicalSuperior" ) {{technicalSuperior.full_name}}
          .c-form__form-row.c-form__form-row--full( v-if="create.Executive" )
            label(class="c-form__form-label") COMERCIAL SUPERIOR
            select(v-model="formData.superior" id="user_type", name="user_type", required)
                option(:value="executiveSuperior.id" v-for="executiveSuperior in listExecutiveSuperior" ) {{executiveSuperior.full_name}}
          .c-form__form-row.c-form__form-row--full( v-if="create.Broker" )
            label(class="c-form__form-label") ESTE BROKER YA ES CLIENTE?    
            b-switch(
              v-model="formData.previousClient"
              true-value="Sí"
              false-value="No"
              ) {{ formData.previousClient }}
          .c-form__form-row.c-form__form-row--full(v-if="create.Broker && formData.previousClient=='Sí'")
            label(class="c-form__form-label") NOMBRE DE BROKER
            select(v-model="formData.businessId" id="name_broker", name="name_broker", required)
                option( :value="broker.id" v-for="broker in listBrokers" ) {{broker.name}}
          .c-form__form-row.c-form__form-row--full(v-if="create.Broker && formData.previousClient=='No'")
            label(for="broker", class="c-form__form-label") NOMBRE DE BROKER
            input(v-model="formData.businessName" id="broker", name="broker", type="text", class="c-form__form-input", required)
          .c-form__form-row.c-form__form-row--full( v-if="create.Broker")
            label(class="c-form__form-label") COMERCIALES ASIGNADOS
            b-taginput(
              v-model="formData.assignedExecutives"
              :data="filteredExecutives"
              autocomplete
              :allow-new="allowNew"
              :open-on-focus="openOnFocus"
              field="full_name"
              icon="label"
              placeholder="Add a tag"
              @typing="getFilteredExecutives")
                template(slot-scope="props") {{props.option.full_name}}
          .c-form__form-row
            label(for="name", class="c-form__form-label") NOMBRE (*)
            input(v-model="formData.name" id="name", name="name", type="text", class="c-form__form-input", required)
          .c-form__form-row
            label(for="lastname", class="c-form__form-label") APELLIDO (*);
            input(v-model="formData.lastname" id="lastname", name="lastname", type="text", class="c-form__form-input", required )
          .c-form__form-row
            label(for="user", class="c-form__form-label") USUARIO (*)
            input(v-model="formData.username" id="user", name="user", type="text", class="c-form__form-input", required)
          .c-form__form-row
            label(for="password", class="c-form__form-label") CONTRASEÑA(*)
            b-input(v-model="formData.password" id="password", name="password", type="password", class="c-form__form-input", password-reveal)
          .c-form__form-row
            label(for="email", class="c-form__form-label") CORREO(*)
            input(v-model="formData.email" id="email", name="email", type="email", class="c-form__form-input", required)
          .c-form__form-row
            label(for="phone", class="c-form__form-label") TELEFONO / CELULAR(*)
            input(v-model="formData.phone" id="phone", name="phone", type="number", class="c-form__form-input", required)
      .c-form__form-row.c-form__form-row--full(v-if="errorMessage")
        h2.headline__title.headline__title--font-size Completar los campos faltantes
      .buttons-wrapper
        b-button( @click="submit" type="is-primary" ) CREAR CUENTA
</template>
<script>
  import { getCompanies } from '../services/services';
  import axios from 'axios';
  import { getExecutiveList, createExecutive } from '../services/User/executive';
  import { getBrokerList, createBroker } from '../services/User/broker';
  import { createTechnical, getTechnicalList } from '../services/User/technical';
  import {
    isExecutive,
    isBroker,
    isBrokerAdministrator,
    isExecutiveNationalSupervisor,
    isTechnical,
  } from '../mixins/user';
import { type } from 'os';

  export default {
    name:"CreateForm",
    data() {
      return {
        formData: {
          previousClient: 'No',
          company:"",
          companies:[],
          executiveType:"",
          technicalType:"",
          superior:null,
          technicalSuperior:null,
          technicalBag: null,
          team:"",
          name:"",
          businessName: "",
          businessId: "",
          lastname:"",
          toBroker:"",
          id:"",
          password:"",
          email:"",
          phone:"",
          assignedExecutives:[]
        },
        listBrokers: [], 
        create: {
          Broker: false,
          Technical: false,
          TechnicalOperative: false,
          TechnicalTeamSupervisor: false,
          Executive: false,
          ExecutiveOperative: false,
          ExecutiveTeamSupervisor: false,
          Operational: false,
        },
        listExecutiveSuperior: [],
        listTechnicalSuperior: [],
        listCompanies:[],
        listTechnicalBags: [],
        filteredCompanies:[],
        filteredExecutives: [],
        isSelectOnly: false,
        companies: [],
        errorMessage: false,
      }
    },
    
    mounted() {
      this.typeCreation();
      getCompanies().then((companies) => {
        this.companies = companies.data;
      });
      
      getBrokerList('business').then((brokerList) => {
        this.listBrokers = brokerList.data;
      });

      getExecutiveList('operative').then((executiveOperativesList) => {
        this.listExecutiveOperatives = executiveOperativesList.data;
      });

      getTechnicalList('bags').then((technicalBagsList) => {
        this.listTechnicalBags = technicalBagsList.data;
      })
    },

    computed: {
      title() {
        let typeUser = "";
        this.create.Executive ?  typeUser = 'Comercial': null;
        this.create.Broker ? typeUser = 'Broker' : null;
        this.create.Operational ? typeUser = 'Operativo' : null;
        this.create.Technical ? typeUser = 'Tecnica' : null;
        return `Crear ${typeUser}`
      },
    },

    methods: {
      selectExecutiveType() {
        const EXECUTIVE_TYPE = {
          TEAM_SUPERVISOR: 1,
          OPERATIVE: 2,
        }
        if(this.formData.executiveType === EXECUTIVE_TYPE.TEAM_SUPERVISOR) {
          this.create.ExecutiveTeamSupervisor = true;
          this.create.ExecutiveOperative = false;
          getExecutiveList('national-supervisor').then((executiveNationalSupervisorsList) => {
            this.listExecutiveSuperior = executiveNationalSupervisorsList.data
          })
        }
        if(this.formData.executiveType === EXECUTIVE_TYPE.OPERATIVE) {
          this.create.ExecutiveOperative = true;
          this.create.ExecutiveTeamSupervisor = false;
          getExecutiveList('team-supervisor').then((executiveTeamSupervisorsList) => {
            this.listExecutiveSuperior = executiveTeamSupervisorsList.data;
          })
        }
      },
      selectTechnicalType() {
        const TECHNICAL_TYPE = {
          TEAM_SUPERVISOR: 1,
          OPERATIVE: 2,
        }
        if(this.formData.technicalType === TECHNICAL_TYPE.TEAM_SUPERVISOR) {
          this.create.TechnicalTeamSupervisor = true;
          this.create.TechnicalOperative = false;
          getTechnicalList('national-supervisor').then((technicalNationalSupervisorsList) => {
            this.listTechnicalSuperior = technicalNationalSupervisorsList.data
          })
        }
        if(this.formData.technicalType === TECHNICAL_TYPE.OPERATIVE) {
          this.create.TechnicalTeamSupervisor = false;
          this.create.TechnicalOperative = true;
          getTechnicalList('team-supervisor').then((technicalTeamSupervisorsList) => {
            this.listTechnicalSuperior = technicalTeamSupervisorsList.data
          })
        }
      },
      getFilteredExecutives(text) {
          this.filteredExecutives = this.listExecutiveOperatives.filter((option) => {
              return option.first_name
                  .toString()
                  .toLowerCase()
                  .indexOf(text.toLowerCase()) >= 0
          })
      },

      getFilteredCompanies(text) {
          this.filteredCompanies = this.companies.filter((option) => {
              return option.name
                  .toString()
                  .toLowerCase()
                  .indexOf(text.toLowerCase()) >= 0
          })
      },

      typeCreation() {
        isExecutive() && this.$route.path === "/create-broker" ? this.create.Broker = true : null;
        isExecutive() && this.$route.path === "/create" ? this.create.Executive = true : null;
        isBrokerAdministrator() ? this.create.Operational = true : null;
        isTechnical() ? this.create.Technical = true : null;
      },

      submit() {
        this.create.Broker ? this.submitCreateBroker() : null;
        this.create.Technical ? this.submitCreateTechnical() : null;
        this.create.Executive ? this.submitCreateExecutive() : null;
        this.create.Operational ? this.submitCreateOperational() : null;
      },

      submitCreateBroker() {
        const body = {
          first_name : this.formData.name,
          last_name : this.formData.lastname,
          username : this.formData.username,
          password : this.formData.password,
          email : this.formData.email,
          phone : this.formData.phone,
          business: {},
          assigned_executives:[],
        }
        this.formData.assignedExecutives.forEach((executive) => {
          body.assigned_executives.push(executive.id);
        });
        this.formData.previousClient =='Sí' ?
          body.business.id = this.formData.businessId :
          body.business.name = this.formData.businessName;
        if(this.formValid(body)){
          this.errorMessage = false;
          createBroker('admin', body).then( result => {
            this.$router.push('/create-confirmation');
          })
        }else{
          this.errorMessage = true;
        }
      },

      submitCreateTechnical() {
        const body = {
          first_name : this.formData.name,
          last_name : this.formData.lastname,
          username : this.formData.username,
          password : this.formData.password,
          email : this.formData.email,
          phone : this.formData.phone,
          superior_id: this.formData.technicalSuperior,
          team_id: this.formData.technicalBag,
        }
        if(this.create.TechnicalOperative){ 
          if(this.formValid(body)){
            this.errorMessage = false;
            createTechnical('operative', body).then((result) => {
              this.$router.push('/create-confirmation');
            })
          }else{
            this.errorMessage = true;
          }  
        }
        if(this.create.TechnicalTeamSupervisor){
          if(this.formValid(body)){
            this.errorMessage = false;
            createTechnical('team-supervisor', body).then((result) => {
              this.$router.push('/create-confirmation');
            })
          }else{
            this.errorMessage = true;
          }
        }
      },

      submitCreateExecutive() {
        const body = {
          first_name : this.formData.name,
          last_name : this.formData.lastname,
          username : this.formData.username,
          password : this.formData.password,
          email : this.formData.email,
          phone : this.formData.phone,
          superior_id: this.formData.superior,
          companies: [],
        }
        this.formData.companies.forEach((company) => {
          body.companies.push(company.company_id);
        });

        if(this.create.ExecutiveTeamSupervisor) {
          if(this.formValid(body)){
            this.errorMessage = false;
            createExecutive('team-supervisor', body).then((result) => {
              this.$router.push('/create-confirmation');
            })
          }else{
            this.errorMessage = true;
          }
        }

        if(this.create.ExecutiveOperative){
          if(this.formValid(body)){
            this.errorMessage = false;
            createExecutive('operative', body).then((result) => {
              this.$router.push('/create-confirmation');
            })
          }else{
            this.errorMessage = true;
          }
        }
      },

      submitCreateOperational() {
        const body = {
          first_name : this.formData.name,
          last_name : this.formData.lastname,
          username : this.formData.username,
          password : this.formData.password,
          email : this.formData.email,
          phone : this.formData.phone,
        }
        if(this.formValid(body)){
          this.errorMessage = false;
          createBroker('operative', body).then( (result)=> {
            this.$router.push('/create-confirmation');
          })
        }else{
          this.errorMessage = true;
        }
      },

      formValid(dataForm){
        const valuesForm = Object.values(dataForm);
        const formValid = valuesForm.reduce(( accumulator, currentvalue ) => {
          return !!accumulator && !!currentvalue;
        })
        return formValid;
      }
    }
  }
</script>
<style lang="scss">
@import '../assets/scss/variables.scss';
.headline__title {
  text-align: center;
}
.create-user {
  margin-top: 50px;
}
.form-wrapper {
  max-width: 700px;
  margin: 0 auto;
}
.title {
  text-align: center;
}
select {
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  height: 50px;
  padding: 10px;
  font-size: 14px;
  background: white;
  &:hover {
    border-color: #b5b5b5;
  }
  &:focus {
    border-color: $primary;
    box-shadow: 0 0 0 0.125em rgba(255,109,70,0.25);
  }
}
input{
  &:hover {
    border-color: #b5b5b5;
  }
  &:focus {
    border-color: $primary;
    box-shadow: 0 0 0 0.125em rgba(255,109,70,0.25);
  }
}
.taginput .taginput-container.is-focusable{
  border: 1px solid #e8e8e8;
  box-shadow: none;
  border-radius: 5px;
  height: 50px;
  padding: 10px;
  font-size: 14px;
  background: white;
  &:hover {
    border-color: #b5b5b5;
  }
  &.is-focused{
    border-color: $primary;
    box-shadow: 0 0 0 0.125em rgba(255,109,70,0.25);
  }
}
.control.has-icons-right .input{
  padding-right: 2.25em;
  border: none;
  box-shadow: none;
  padding-bottom: 13px;
}
.control.has-icons-right .icon.is-right {
  margin-top: 6px;
}
</style>